import React from "react";
import { Habit } from "../types";
import { Button } from "../components/Button";

interface HabitsSettingsSectionProps {
  habits: Habit[];
  onAddHabit: () => void;
  onEditHabit: (habit: Habit) => void;
}

export const HabitsSettingsSection: React.FC<HabitsSettingsSectionProps> = ({
  habits,
  onAddHabit,
  onEditHabit,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3 style={{ margin: 0 }}>Habits</h3>
        <Button size="sm" onClick={onAddHabit}>
          Add Habit
        </Button>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>
        {habits.map((habit, index) => (
          <div
            key={habit.id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              margin: "0 -16px",
              backgroundColor: "#fff",
              borderTop: index === 0 ? "0.5px solid #ccc" : "none",
              borderBottom: "0.5px solid #ccc",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <span style={{
                opacity: habit.archived ? 0.5 : 1,
                textDecoration: habit.archived ? "line-through" : "none"
              }}>
                {habit.name}
              </span>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onEditHabit(habit)}
            >
              Edit
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};